import Avatar from './Avatar'
import Rank from './Rank'

type TeamEntry = {
  rank?: number | null
  score: number
  points: number
  holesRegistred: number
  team: { id: string; name?: string | null }
}

const TeamRow = ({
  entry,
  isYou,
  isNet,
  onClick,
}: {
  entry: TeamEntry
  /** True when the auth'd player is on this team — green-50 highlight. */
  isYou: boolean
  isNet: boolean
  /** Tap-the-row opens the detail sheet — whole row is the hit target. */
  onClick?: () => void
}) => (
  <li className="border-b border-ink-100 last:border-b-0">
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 py-3 px-4 text-left active:bg-ink-100 transition-colors ${
        isYou ? 'bg-green-50' : ''
      }`}
    >
      <Rank rank={entry.rank} />
      <Avatar name={entry.team.name ?? '—'} size={32} />
      <div className="flex-1 text-sm font-semibold text-ink-900 truncate">
        {entry.team.name ?? 'Uten navn'}
        {isYou ? (
          <span className="ml-2 text-xs font-bold text-green-700">
            · Ditt lag
          </span>
        ) : null}
      </div>
      <div className="text-right">
        <div className="font-mono num font-bold text-ink-900">
          {isNet ? entry.score : entry.points}
        </div>
        <div className="text-[10px] text-ink-500 num">
          {entry.holesRegistred}/18
        </div>
      </div>
    </button>
  </li>
)

export default TeamRow
